import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({ providedIn: "root" })
export class ConfigptoService {
  public url: string;
  public urlUser: string;
  public token;
  public headers;
  public company_id_usuario_logueado;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));
    this.company_id_usuario_logueado = JSON.parse(localStorage.getItem("companyId"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this._http
      .post<any>(url, params, { headers: this.headers })
      .pipe(
        map(response => {
          if (response.code === 404) {
            // this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          return response;
        }),
        catchError((error: HttpErrorResponse) => {
          // Handle and forward the error
          console.error('An error occurred:', error);
          return throwError('Something went wrong. Please try again later.');
        })
      );
  }

  create(json): Observable<any> {
    return this.petition(`${this.url}/configyearspto/new`, json);
  }

  list(): Observable<any> {
    return this.petition(`${this.url}/configyearspto/list`);
  }

  probationalPeriod(): Observable<any> {
    return this.petition(
      `${this.url}/company/detailsetup/${this.company_id_usuario_logueado}`
    );
  }

  updateProbation(json): Observable<any> {
    return this.petition(`${this.url}/company/setprobationperiod`, json);
  }

  setptohourslimit(json): Observable<any> {
    return this.petition(`${this.url}/company/setptohourslimit`, json);
  }

  delete(id): Observable<any> {
    return this.petition(`${this.url}/configyearspto/remove/${id}`);
  }
}
